import { render, staticRenderFns } from "./my-business-monitoring-service.vue?vue&type=template&id=aadb4976&scoped=true"
import script from "./my-business-monitoring-service.vue?vue&type=script&lang=js"
export * from "./my-business-monitoring-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadb4976",
  null
  
)

export default component.exports